import { render, staticRenderFns } from "./DraftClients.vue?vue&type=template&id=61887c64&scoped=true"
import script from "./DraftClients.vue?vue&type=script&lang=ts"
export * from "./DraftClients.vue?vue&type=script&lang=ts"
import style0 from "./DraftClients.vue?vue&type=style&index=0&id=61887c64&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61887c64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61887c64')) {
      api.createRecord('61887c64', component.options)
    } else {
      api.reload('61887c64', component.options)
    }
    module.hot.accept("./DraftClients.vue?vue&type=template&id=61887c64&scoped=true", function () {
      api.rerender('61887c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Clients/DraftClients.vue"
export default component.exports